import { createContext, useContext } from 'react';
import { useWindowDimensions } from 'react-native';

import { useIsDesktopWeb } from '@/feature/responsive-design/hooks/use-is-desktop-web';
import {
    DESKTOP_PAGE_MARGIN,
    MAX_DESKTOP_WEB_WIDTH,
    SIDE_RAIL_CONTENT_GAP,
    SIDE_RAIL_WIDTH,
} from '@/utils/constants-platform-specific';

export const CasinoLobbyContentWidthContext = createContext(0);

/**
 * Width available to the casino lobby content. Lobby layouts must size their cards from this
 * instead of the window width: on desktop web the content column sits right of the side rail
 * inside the capped page container, so the window width overstates the available space.
 */
export const useCasinoLobbyContentWidth = () => {
    const measuredWidth = useContext(CasinoLobbyContentWidthContext);
    const { width } = useWindowDimensions();
    const isDesktopWeb = useIsDesktopWeb();

    if (measuredWidth) {
        return measuredWidth;
    }

    if (!isDesktopWeb) {
        return width;
    }

    const containerWidth = Math.min(MAX_DESKTOP_WEB_WIDTH, width - DESKTOP_PAGE_MARGIN * 2);
    return containerWidth - SIDE_RAIL_WIDTH - SIDE_RAIL_CONTENT_GAP;
};
